<template>
  <v-autocomplete
    :label="label"
    placeholder="Введите название"
    persistent-hint
    hide-no-data
    item-text="name"
    item-value="id"
    v-bind="$attrs"
    v-on="$listeners"
    :small-chips="multiple"
    :multiple="multiple"
    :return-object="returnObject"
    :loading="loading"
    :items="items"
  />
</template>

<script>
import { CustomerDiseasesRepository } from "@/modules/diseases/customer-diseases.repository.js";

/**
 * Если передан флаг returnObject тогда возвращаемое значения будет в виде объекта
 * {id: number, code: string, name: string}
 */
export default {
  name: "PatientDiseasesList",

  props: {
    label: {
      type: String,
      default: "Выберите заболевание",
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    returnObject: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      loading: false,
      items: [],
    };
  },

  async mounted() {
    this.items = (await CustomerDiseasesRepository.getList(this.$store.state.customer.id))
      .filter(item => item.icd10)
      .map(item => ({
        id: item.icd10.id,
        code: item.icd10.code,
        name: item.icd10.translation.name,
      }));
  },
};
</script>

<style scoped></style>
